<template>
  <div class="ip-filters-page">
    <div class="ip-filters-page_header">
      <div class="ip-filters-page_header-h1">
        <h1>Налаштування доступу по IP</h1>
        <sChip
          class="my-auto"
          :text="convertItems.length"/>
      </div>
      <div class="text-right">
        <sButton
          class="my-auto"
          color="red"
          :disabled="disabled"
          icon="repeat"
          small
          type="text"
          @click="refresheCache()">
          Скинути кеш
        </sButton>
        <sButton
          class="ml-10"
          :disabled="disabled"
          icon="plus-circle"
          small
          type="text"
          @click="openModal()">
          {{ $t('Common.Add') }}
        </sButton>
      </div>
    </div>
    <sModal
      :closable="false"
      :mask-closable="false"
      :title="modal.state === 'edit' ? 'Редагування' : 'Створення'"
      :value="!!modal.state"
      @close="closeModal">
      <sForm
        v-if="modal.item"
        ref="ipForm"
        label-position="top"
        :model="modal.item"
        :rules="modal.rules">
        <sFormItem
          label="Тип фільтрації"
          prop="filterType">
          <sRadioGroup
            v-model="modal.item.filterType"
            data-qa="filter-type-group"
            :disabled="loading"
            row>
            <sRadio
              v-for="filterTypeItem in spr.filterType"
              :key="filterTypeItem.key"
              :data-qa="'filter-type-' + filterTypeItem.key"
              :label="filterTypeItem.key">
              {{ filterTypeItem.label }}
            </sRadio>
          </sRadioGroup>
        </sFormItem>
        <sFormItem
          :label="$t('clients')"
          prop="clients">
          <div
            v-for="(client, clientIndex) in modal.item.clients"
            :key="clientIndex"
            class="flex gap-5 margin-top-5">
            <sSelect
              :disabled="disabled"
              placeholder="Оберіть значення"
              :value.sync="client.clientPriorityType">
              <sOption
                v-for="clientPriorityBllTypeItem in spr.clientPriorityBllType"
                :key="`clientPriorityBllType-${clientPriorityBllTypeItem.key}`"
                class="px-8"
                :data-qa="`clientPriorityBllType-${clientPriorityBllTypeItem.key}`"
                :label="clientPriorityBllTypeItem.label"
                :value="clientPriorityBllTypeItem.key"/>
            </sSelect>
            <sInput
              :disabled="disabled"
              max-length="4000"
              placeholder="Заповніть значення"
              :value.sync="client.id"/>
            <sButton
              color="red"
              icon="delete"
              small
              type="text"
              @click="deleteProp('clients', clientIndex)"/>
          </div>
          <sButton
            class="mt-3"
            icon="plus-circle"
            small
            type="text"
            @click="addedProp('clients')">
            {{ $t('Common.Add') }}
          </sButton>
        </sFormItem>
        <sFormItem
          :label="$t('ipAddresses')"
          prop="ipAddresses">
          <div
            v-for="(ipAddress, ipAddressIndex) in modal.item.ipAddresses"
            :key="ipAddressIndex"
            class="flex gap-5 margin-top-5">
            <sInput
              :disabled="disabled"
              max-length="4000"
              placeholder="Заповніть значення"
              :value.sync="ipAddress.ip"/>
            <sButton
              color="red"
              :disabled="disabled"
              icon="delete"
              small
              type="text"
              @click="deleteProp('ipAddresses', ipAddressIndex)"/>
          </div>
          <sButton
            class="mt-3"
            icon="plus-circle"
            small
            type="text"
            @click="addedProp('ipAddresses')">
            {{ $t('Common.Add') }}
          </sButton>
        </sFormItem>
      </sForm>
      <div
        key="footer"
        slot="footer">
        <sButton
          data-qa="btn-apply"
          :loading="loading"
          @click="handleSubmit">
          {{ modal.state === 'edit' ? $t('Common.Save') : $t('Common.Add') }}
        </sButton>
        <sButton
          data-qa="btn-close"
          type="text"
          @click="closeModal">
          {{ $t('Common.Cancel') }}
        </sButton>
      </div>
    </sModal>
    <template v-if="loading">
      loading
    </template>
    <template v-else>
      <div
        class="ip-filters-page_row-head">
        <div/>
        <div
          class="ip-filters-page_value-head">
          Користувачі/Організації
        </div>
        <div
          class="ip-filters-page_value-head">
          IP
        </div>
        <div/>
      </div>

      <div class="ip-filters-page_grid">
        <sAlert
          v-if="!convertItems.length"
          banner>
          Даних немає
        </sAlert>
        <div
          v-else
          v-for="(item) in convertItems"
          :key="item.id"
          class="ip-filters-page_row"
          :class="item.filterType==='ALLOW_CLIENT' ? 'is-allow' : 'is-dissalow'"
          @click.stop="item.collapse = !item.collapse">
          <div>
            <sTooltip
              :content="item.filterType==='ALLOW_CLIENT' ? 'Дозволено' : 'Заборонено'"
              placement="top"
              trigger="hover"
              width="200">
              <sIcon
                :color="item.filterType==='ALLOW_CLIENT' ? 'var(--alert-success-icon)' : 'var(--alert-error-icon)'"
                :type="item.filterType==='ALLOW_CLIENT' ? 'accept' : 'cancel'"/>
            </sTooltip>
          </div>
          <div>
            <div
              v-for="(client, clientIndex) in item.clients"
              :key="`${item.id}_ip_${client.id}_${clientIndex}`"
              class="ip-filters-page_value-value">
              <b>{{ client.typeLabel }}</b>: {{ client.id }}
            </div>
          </div>
          <div>
            <div
              v-for="(ipAddress, ipAddressIndex) in item.ipAddresses"
              :key="`${item.id}_ip_${ipAddress.ip}_${ipAddressIndex}`"
              class="ip-filters-page_value-value">
              {{ ipAddress.ip }}
            </div>
          </div>
          <div class="flex">
            <sButton
              color="green"
              :disabled="disabled"
              icon="edit"
              small
              type="text"
              @click="openModal(item)"/>
            <sButton
              color="red"
              :disabled="disabled"
              icon="delete"
              small
              type="text"
              @click="deleteItem(item)"/>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import ipFilters from '@/api/ipFilters'
import functionMixin from 'mixins/functionMixin'
import functionRandom from 'mixins/functionRandom'

const api = new ipFilters()

const itemTemplate = {
  id: null,
  filterType: null,
  clients: [
    {
      clientPriorityType: 'ORGANIZATION_IT_ID'
    }
  ],
  ipAddresses: [
    {}
  ]
}

export default {
  name: 'IpFilters',
  mixins: [
    functionMixin,
    functionRandom
  ],
  data() {
    const that = this
    return {
      loading: true,
      disabled: false,
      spr: {
        clientPriorityBllType: [
          {key: 'USER_LOGIN', label: 'Логін'},
          {key: 'ORGANIZATION_IT_ID', label: 'Організація'},
        ],
        filterType: [
          {key: 'ALLOW_CLIENT', label: 'Дозволити'},
          {key: 'EXCLUDE_CLIENT', label: 'Заборонити'}
        ]
      },
      convertItems: [],
      modal: {
        item: null,
        state: null,
        rules: {
          filterType: {
            type: 'string',
            required: true,
            trigger: 'change',
            max: 4000,
            message: that.$t('Validate.Required')
          },
          clients: {
            required: true,
            trigger: 'change',
            validator(rule, value, callback) {
              if (!value?.length) {
                callback(new Error(that.$t('Validate.Required')))
              }
              if (value.find(i => !i.id)) {
                callback(new Error('Нужно заполнить свойство'))
              }
              callback()
            }
          },
          ipAddresses: {
            required: true,
            trigger: 'change',
            validator(rule, value, callback) {
              if (!value?.length) {
                callback(new Error(that.$t('Validate.Required')))
              }
              if (value.find(i => !i.ip)) {
                callback(new Error('Нужно заполнить свойство'))
              }
              callback()
            }
          },
        }
      }
    }
  },
  methods: {
    addedProp(propName) {
      this.modal.item[propName].push({})
    },
    deleteProp(propName, index) {
      this.modal.item[propName].splice(index, 1)
    },
    refresheCache() {
      api.refresheCache()
      this.$notice.info({
        title: 'Скинути кеш',
        message: this.$t('Common.done'),
        duration: 2
      })

    },
    handleSubmit() {
      this.$refs.ipForm.validate()
        .then(async (valid) => {
          if (!valid) { return }

          const apiMode = this.modal.state === 'create' ? api.createFilter : api.updateFilter
          const model = this.modal.item
          model.clients.forEach((item) => {
            delete item.typeLabel
          })
          apiMode(this.modal.item)
            .then((result) => {
              const item = this.createConvertItems([result])[0]
              if (this.modal.item.id) {
                const index = this.convertItems.findIndex(el => el.id === this.modal.item.id)
                this.convertItems[index] = item
              } else {
                this.convertItems.push(item)
              }
              this.closeModal()
              this.refresheCache()
            })
        })
    },
    deleteItem(item) {
      this.disabled = true

      const deleteFn = (itemId) => {
        api.deleteFilter(itemId)
          .then(() => {
            const index = this.convertItems.findIndex(el => el.id === itemId)
            this.convertItems.splice(index, 1)
            this.disabled = false

            this.refresheCache()
            this.$Modal.remove()
          })
      }

      this.$Modal.confirm({
        title: this.$t('Purchasing.Remove'),
        content: 'Точно видалити?',
        closable: true,
        okText: this.$t('Tenders.Yes'),
        cancelText: this.$t('Tenders.No'),
        loading: true,
        onOk: () => deleteFn(item.id),
        onCancel: () => {
          this.disabled = false
          this.$Modal.remove()
        },
        width: 450,
      })
    },
    closeModal() {
      this.modal.item = null
      this.modal.state = null
    },
    openModal(item) {
      let state = item ? 'edit' : 'create'
      let itemEdit = this.$_.cloneDeep(item || itemTemplate)

      this.modal.item = itemEdit
      this.modal.state = state
    },
    createConvertItems(items) {
      const setLabel = (items, spr) => {
        items?.forEach(item => {
          item.typeLabel = spr.find(i => i.key === item.clientPriorityType).label
        })
        return items
      }

      const result = this.$_removeTypename(items).map((item) => ({
        id: item.id,
        filterType: item.filterType,
        clients: setLabel(item.clients, this.spr.clientPriorityBllType),
        ipAddresses: item.ipAddresses
      }))

      return result
    },
    async getItems() {
      this.disabled = true
      this.convertItems = []
      api.getIpFilters()
        .then((result) => {
          const items = this.createConvertItems(result)
          this.$set(this, 'convertItems', items)
        })
        .finally(() => {
          this.disabled = false
          this.loading = false
        })
    }
  },
  computed: {},
  components: {},
  created() {
    this.getItems()
  },
  props: {},
}
</script>
<style scoped lang="scss">
.ip-filters-page {
  max-width: 1024px;
  margin: 0 auto;
  &_header {
    display: grid;
    align-items: flex-end;
    grid-template-columns: auto 500px;
    margin-bottom: 10px;
    &-h1 {
      display: grid;
      grid-template-columns: auto 30px;
      justify-content: start;
      gap: 10px;
    }
  }
  &_grid {
    display: grid;
    gap: 1px;
  }
  &_grid>*:last-child {
    border-radius: 0 0 10px 10px;
  }
  &_row {
    display: grid;
    gap: 1px;
    grid-template-columns: 49px auto 524px 79px;
    text-align: left;
    color: var(--text-color) !important;
    font-size: 14px;
    line-height: 18px;
    background-color: var(--v-main__green-base) !important;
    border-right: 1px solid var(--v-main__green-base) !important;
    /*&>* {
      border-right: 1px solid var(--v-main__green-base) !important;
      border-bottom: 1px solid var(--v-main__green-base) !important;
      padding: 10px;
    }*/
    &>div {
      padding: 10px;
      background-color: var(--v-main__light_green-base) !important;
    }
    &-head {
      display: grid;
      grid-template-columns: 50px auto 525px 80px;
      text-align: left;
      border-radius: 10px 10px 0 0;
      // background-color: var(--v-secondary__green_chosen-base) !important;


      background-color: var(--v-secondary__green_chosen-base) !important;
      color: var(--v-secondary__green_not_active-base);
      font-weight: 500;
      height: 40px;
      font-size: 11px !important;
      text-transform: uppercase;
      position: relative;
      &>* {
        border-right: 1px solid var(--v-main__green-base) !important;
        border-bottom: 1px solid var(--v-main__green-base) !important;
        padding: 10px;
      }
    }
    &.is-dissalow {
      //border-left: 3px solid var(--alert-error-icon);
    }
    &.is-allow {
      //border-left: 3px solid var(--alert-success-icon);
    }
  }
  &_value-head {
    font-weight: 500;
  }
  &_value-row {
    display: grid;
    gap: 5px;
    grid-template-columns: 25% 25% 25% 25%;
  }
}
</style>
